export default __webpack_public_path__ + "static/img_2_2-1927d8a043c6585d95c83b363ee7f7e5.jpg";